import axios from "axios";
import { API_BASE_URL } from "../../../config";

export const checkExistingQuote = async (jobId, businessUserId) =>
{
    try
    {
        const response = await axios.get(`${API_BASE_URL}/api/jobs/quote/checkQuote`, {
            params: {
                jobId,
                businessUserId
            },
        });
        return response.data;
    } catch (error)
    {
        console.error("Error fetching Job Deatils:", error);
        throw error;
    }
};
